import React from 'react';

import DateFormatter from './DateFormatter';
import NumericFormatter from './NumericFormatter';

const LotAttributeWorkspaceFormatter = props => {
  const { attributeConfig, attributeValues } = props.dependentValues;
  if (!attributeConfig || !attributeValues || attributeValues.length === 0) {
    return <div />;
  }

  const attrId = attributeConfig.id;
  const value = attributeValues.find(attr => attr.attributeConfig && attrId === attr.attributeConfig.id);
  if (!value) return <div />;
  switch (attributeConfig.attributeType) {
    case 'NUMERIC':
      return <NumericFormatter {...props} align="left" value={value.doubleValue} />;
    case 'INTEGER':
      return <NumericFormatter {...props} type="integer" align="left" value={value.integerValue} />;
    case 'DATE':
      return <DateFormatter {...props} value={value.dateValue} />;
    case 'REFERENCE':
      const description = value.referenceValue && value.referenceValue.description;
      return <div title={description}>{description}</div>;
    default:
      return <div title={value.textValue}>{value.textValue}</div>;
  }
};

export default LotAttributeWorkspaceFormatter;
